/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BuildingKindEnum = 1 | 2 | 3 | 4 | 5 | 6;

export const BuildingKindEnum = {
    NUMBER_1: 1 as BuildingKindEnum,
    NUMBER_2: 2 as BuildingKindEnum,
    NUMBER_3: 3 as BuildingKindEnum,
    NUMBER_4: 4 as BuildingKindEnum,
    NUMBER_5: 5 as BuildingKindEnum,
    NUMBER_6: 6 as BuildingKindEnum
};

